export default "__VITE_ASSET__q0Ce76fK__"